"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ManualColumnMove = void 0;
var _manualColumnMove = require("./manualColumnMove");
exports.PLUGIN_KEY = _manualColumnMove.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _manualColumnMove.PLUGIN_PRIORITY;
exports.ManualColumnMove = _manualColumnMove.ManualColumnMove;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualColumnMove/index.js
// module id = 1455
// module chunks = 0